const addNewLocationReqMaker = locations => {
  const newLocations = locations.filter(
    location => location.newItem.new === true,
  )
  return newLocations.map(location => {
    return {
      raw: location,
      serialized: {
        name: location.name,
        shapeType: location.shapeType,
        shape: location.shape,
      },
    }
  })
}

export default addNewLocationReqMaker
